module.exports = __webpack_public_path__ + "img/building.2df65070.png";